// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card > * {
  border: 1px solid rgba(236, 239, 241, 0.2);
  border-radius: 15px;
}
.card:nth-child(1) {
  --hue: 44;
  --saturation: 100%;
  --lightness: 50%;
}
.card:nth-child(2) {
  --hue: 177;
  --saturation: 19%;
  --lightness: 70%;
}
.card:nth-child(3) {
  --hue: 54;
  --saturation: 100%;
  --lightness: 55%;
}

:host ::ng-deep p-card {
  min-height: 775px;
}
:host ::ng-deep p-card .p-card {
  border-radius: 0.75rem;
  padding: 2rem 1rem;
  border: 1px solid var(--surface-100);
  background: var(--surface-background);
  position: relative;
  box-shadow: 0px 0px 1px 0px rgba(212, 154, 32, 0.15), 0px 6px 12px 0px rgba(212, 154, 32, 0.15);
  height: 100%;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep p-card .p-card:hover .btn--gradient:not(:disabled):after, :host ::ng-deep p-card .p-card:focus .btn--gradient:not(:disabled):after {
  opacity: 1;
}
:host ::ng-deep p-card .p-card-footer {
  margin-top: auto;
}
:host ::ng-deep p-card p-header img,
:host ::ng-deep p-card p-header div.p-skeleton-circle {
  translate: -50% -50%;
  left: 50%;
}
:host ::ng-deep p-card .p-card-body {
  padding-bottom: 0 !important;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep p-card .product-price span:first-child {
  line-height: 3.5rem;
}
:host ::ng-deep p-card .product-price span:last-child {
  line-height: 2rem;
}
:host ::ng-deep p-card .p-card-content {
  height: 100%;
  padding-block: 0 !important;
}
:host ::ng-deep p-card .product-list li i {
  font-size: 12px;
  color: black;
}
:host ::ng-deep p-card .product-list li i:before {
  position: relative;
  top: -3px;
  left: -1px;
}
:host ::ng-deep p-card p-button:not(.view_more) .p-button {
  border: 1px solid rgba(236, 239, 241, 0.2);
}
:host ::ng-deep p-card .view_more {
  width: -moz-fit-content;
  width: fit-content;
}
@media (max-width: 540px) {
  :host ::ng-deep p-card:nth-child(3) {
    min-height: initial;
  }
}
:host ::ng-deep .cta {
  bottom: calc(4rem + 1px);
  left: calc(3.25rem + 2px);
  width: calc(100% - 6.5rem - 4px);
  height: 50px;
  border: 1px solid transparent;
  background-color: hsl(var(--hsl));
  box-shadow: 0 0 0 1px hsl(var(--hsl));
  padding: 0.75rem 1.25rem;
  font-size: 0.93rem;
  letter-spacing: 0.15px;
  font-family: Roboto, Helvetica, sans-serif;
}
:host ::ng-deep .is_trial .cta {
  bottom: calc(6rem + 4px);
}
:host ::ng-deep .is_customer .cta {
  font-size: 1rem;
  letter-spacing: 0.6px;
  font-weight: 400 !important;
}
:host ::ng-deep .fa-shopify.text-5xl {
  color: #85b043;
}
:host ::ng-deep .home-section .overlay .cta {
  bottom: 8rem;
}
:host ::ng-deep .home-section .is_trial .cta {
  bottom: 10.125rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/products/products.component.scss"],"names":[],"mappings":"AACE;EACE,0CAAA;EACA,mBAAA;AAAJ;AAGE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AADJ;AAGE;EACE,UAAA;EACA,iBAAA;EACA,gBAAA;AADJ;AAGE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AADJ;;AAME;EACE,iBAAA;AAHJ;AAKI;EACE,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,qCAAA;EACA,kBAAA;EACA,+FAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;AAJN;AAQQ;EACE,UAAA;AANV;AAWI;EACE,gBAAA;AATN;AAaM;;EAEE,oBAAA;EACA,SAAA;AAXR;AAeI;EACE,4BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAbN;AAiBM;EACE,mBAAA;AAfR;AAkBM;EACE,iBAAA;AAhBR;AAoBI;EACE,YAAA;EACA,2BAAA;AAlBN;AAuBQ;EACE,eAAA;EACA,YAAA;AArBV;AAuBU;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AArBZ;AA2BI;EACE,0CAAA;AAzBN;AA4BI;EACE,uBAAA;EAAA,kBAAA;AA1BN;AA8BE;EACE;IACE,mBAAA;EA5BJ;AACF;AA+BE;EACE,wBAAA;EACA,yBAAA;EACA,gCAAA;EACA,YAAA;EACA,6BAAA;EACA,iCAAA;EACA,qCAAA;EACA,wBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0CAAA;AA7BJ;AAiCI;EACE,wBAAA;AA/BN;AAmCE;EACE,eAAA;EACA,qBAAA;EACA,2BAAA;AAjCJ;AAoCE;EACE,cAAA;AAlCJ;AAqCE;EACE,YAAA;AAnCJ;AAsCE;EACE,iBAAA;AApCJ","sourcesContent":[".card {\r\n  > * {\r\n    border: 1px solid #eceff133;\r\n    border-radius: 15px;\r\n  }\r\n\r\n  &:nth-child(1) {\r\n    --hue: 44;\r\n    --saturation: 100%;\r\n    --lightness: 50%;\r\n  }\r\n  &:nth-child(2) {\r\n    --hue: 177;\r\n    --saturation: 19%;\r\n    --lightness: 70%;\r\n  }\r\n  &:nth-child(3) {\r\n    --hue: 54;\r\n    --saturation: 100%;\r\n    --lightness: 55%;\r\n  }\r\n}\r\n\r\n:host ::ng-deep {\r\n  p-card {\r\n    min-height: 775px;\r\n\r\n    .p-card {\r\n      border-radius: 0.75rem;\r\n      padding: 2rem 1rem;\r\n      border: 1px solid var(--surface-100);\r\n      background: var(--surface-background);\r\n      position: relative;\r\n      box-shadow: 0px 0px 1px 0px rgba(#d49a20, 0.15),\r\n        0px 6px 12px 0px rgba(#d49a20, 0.15);\r\n      height: 100%;\r\n      display: flex;\r\n      flex-direction: column;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        .btn--gradient:not(:disabled):after {\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n\r\n    .p-card-footer {\r\n      margin-top: auto;\r\n    }\r\n\r\n    p-header {\r\n      img,\r\n      div.p-skeleton-circle {\r\n        translate: -50% -50%;\r\n        left: 50%;\r\n      }\r\n    }\r\n\r\n    .p-card-body {\r\n      padding-bottom: 0 !important;\r\n      flex-grow: 1;\r\n      display: flex;\r\n      flex-direction: column;\r\n    }\r\n\r\n    .product-price {\r\n      span:first-child {\r\n        line-height: 3.5rem;\r\n      }\r\n\r\n      span:last-child {\r\n        line-height: 2rem;\r\n      }\r\n    }\r\n\r\n    .p-card-content {\r\n      height: 100%;\r\n      padding-block: 0 !important;\r\n    }\r\n\r\n    .product-list {\r\n      li {\r\n        i {\r\n          font-size: 12px;\r\n          color: black;\r\n\r\n          &:before {\r\n            position: relative;\r\n            top: -3px;\r\n            left: -1px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    p-button:not(.view_more) .p-button {\r\n      border: 1px solid #eceff133;\r\n    }\r\n\r\n    .view_more {\r\n      width: fit-content;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 540px){\r\n    p-card:nth-child(3) {\r\n      min-height: initial;\r\n    }\r\n  }\r\n\r\n  .cta {\r\n    bottom: calc(4rem + 1px);\r\n    left: calc(3.25rem + 2px);\r\n    width: calc(100% - 6.5rem - 4px);\r\n    height: 50px;\r\n    border: 1px solid transparent;\r\n    background-color: hsl(var(--hsl));\r\n    box-shadow: 0 0 0 1px hsl(var(--hsl));\r\n    padding: 0.75rem 1.25rem;\r\n    font-size: 0.93rem;\r\n    letter-spacing: 0.15px;\r\n    font-family: Roboto, Helvetica, sans-serif;\r\n  }\r\n\r\n  .is_trial {\r\n    .cta {\r\n      bottom: calc(6rem + 4px);\r\n    }\r\n  }\r\n\r\n  .is_customer .cta {\r\n    font-size: 1rem;\r\n    letter-spacing: 0.6px;\r\n    font-weight: 400 !important;\r\n  }\r\n\r\n  .fa-shopify.text-5xl {\r\n    color: #85b043;\r\n  }\r\n\r\n  .home-section .overlay .cta {\r\n    bottom: 8rem;\r\n  }\r\n\r\n  .home-section .is_trial .cta {\r\n    bottom: 10.125rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
